import React from 'react';
import { CompanyDashboardProps } from '../constants';
import { ReactComponent as CurrentIcon } from 'assets/icons/line_current.svg';
import { ReactComponent as TargetIcon } from 'assets/icons/line_target.svg';

const { LEGEND_TEXT_FILL } = CompanyDashboardProps;

export const xAxisLabelContent = (xPos?: boolean, targetName?: string) => (
  <g>
    <g transform="translate(-20, 0)">
      <CurrentIcon x={xPos ? '44%' : '40%'} y="89.4%" width="41" height="7" />
      <text
        x={xPos ? '48%' : '48%'}
        y="88.4%"
        textAnchor="start"
        fill={LEGEND_TEXT_FILL}
        dy="0.9em"
        fontSize="0.8rem">
        Current
      </text>
    </g>
    {targetName && (
      <g transform="translate(20, 0)">
        <TargetIcon x={xPos ? '50%' : '53%'} y="89.2%" width="41" height="7" />
        <text
          x={xPos ? '54%' : '61%'}
          y="88%"
          textAnchor="start"
          fill={LEGEND_TEXT_FILL}
          dy="0.9em"
          fontSize="0.8rem">
          {targetName}
        </text>
      </g>
    )}
  </g>
);
